import React, { useState } from 'react';
import HeroBanner from '../components/HeroBanner';
import { contactContent } from '../mock';
import { toast } from '../hooks/use-toast';
import { Toaster } from '../components/ui/toaster';

const Contact = () => {
  const [form, setForm] = useState({ name: '', email: '', message: '' });
  const [submitting, setSubmitting] = useState(false);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!form.name || !form.email || !form.message) {
      toast({ title: 'Missing info', description: 'Please fill in every field.' });
      return;
    }
    setSubmitting(true);
    // Store locally as demo (mock)
    const existing = JSON.parse(localStorage.getItem('uo_messages') || '[]');
    existing.push({ ...form, submittedAt: new Date().toISOString() });
    localStorage.setItem('uo_messages', JSON.stringify(existing));

    setTimeout(() => {
      setSubmitting(false);
      setForm({ name: '', email: '', message: '' });
      toast({
        title: 'Message sent',
        description: 'Thank you \u2014 we will be in touch shortly.',
      });
    }, 700);
  };

  return (
    <>
      <HeroBanner image={contactContent.heroImage} quote={contactContent.heroQuote} tall={false} />

      <section className="bg-[#e5dfe9] py-24 md:py-32">
        <div className="max-w-5xl mx-auto px-6">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-14">
            {/* Left: address & map */}
            <div>
              <h2 className="font-sans font-bold text-neutral-800 mb-6" style={{ fontSize: '18px' }}>
                Contact
              </h2>

              <div className="rounded-sm overflow-hidden border border-neutral-500/30 mb-8 shadow-sm">
                <iframe
                  title="Urban Outsourcing office location"
                  src={contactContent.mapEmbed}
                  width="100%"
                  height="260"
                  style={{ border: 0 }}
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                />
              </div>

              <div className="space-y-2 text-neutral-700 font-sans" style={{ fontSize: '17px', lineHeight: '1.75' }}>
                <p>{contactContent.address.line1}</p>
                <p>{contactContent.address.line2}</p>
                <p className="pt-2">{contactContent.phone}</p>
                <p>
                  <a
                    href={`mailto:${contactContent.email}`}
                    className="underline decoration-neutral-400 underline-offset-4 hover:text-neutral-900"
                  >
                    {contactContent.email}
                  </a>
                </p>
              </div>
            </div>

            {/* Right: contact form (mock) */}
            <div>
              <h2 className="font-sans font-bold text-neutral-800 mb-6" style={{ fontSize: '18px' }}>
                Send us a note
              </h2>
              <form onSubmit={handleSubmit} className="space-y-5">
                <div>
                  <label className="block text-[12px] tracking-[0.18em] uppercase text-neutral-600 mb-2">
                    Name
                  </label>
                  <input
                    name="name"
                    value={form.name}
                    onChange={handleChange}
                    className="w-full bg-white/60 border border-neutral-500/30 rounded-sm px-4 py-3 text-neutral-800 focus:outline-none focus:border-neutral-700 transition-colors"
                  />
                </div>
                <div>
                  <label className="block text-[12px] tracking-[0.18em] uppercase text-neutral-600 mb-2">
                    Email
                  </label>
                  <input
                    name="email"
                    type="email"
                    value={form.email}
                    onChange={handleChange}
                    className="w-full bg-white/60 border border-neutral-500/30 rounded-sm px-4 py-3 text-neutral-800 focus:outline-none focus:border-neutral-700 transition-colors"
                  />
                </div>
                <div>
                  <label className="block text-[12px] tracking-[0.18em] uppercase text-neutral-600 mb-2">
                    Message
                  </label>
                  <textarea
                    name="message"
                    value={form.message}
                    onChange={handleChange}
                    rows={5}
                    className="w-full bg-white/60 border border-neutral-500/30 rounded-sm px-4 py-3 text-neutral-800 focus:outline-none focus:border-neutral-700 transition-colors resize-none"
                  />
                </div>
                <button
                  type="submit"
                  disabled={submitting}
                  className="inline-block text-[13px] tracking-[0.22em] font-sans font-medium border border-neutral-700 text-neutral-800 rounded-full px-8 py-3 hover:bg-neutral-800 hover:text-white transition-colors disabled:opacity-60"
                >
                  {submitting ? 'SENDING\u2026' : 'SEND MESSAGE'}
                </button>
              </form>
            </div>
          </div>
        </div>
      </section>
      <Toaster />
    </>
  );
};

export default Contact;
